import { Resolver } from 'did-resolver';
import { getResolver as getResolver$1 } from 'web-did-resolver';
import { getDomain } from '../../lib';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const SUPPORTED_CONTENT_TYPES = [
  "application/did+json",
  "application/did+ld+json"
];
const getResolver = /* @__PURE__ */ __name(() => {
  return new Resolver({
    ...getResolver$1()
  });
}, "getResolver");
const queryDidDocument = /* @__PURE__ */ __name(async ({ domain, did }) => {
  if (!did && !domain) {
    throw new Error("Missing domain");
  }
  if (!did && domain) {
    let domainHostname = getDomain(domain);
    if (!domainHostname) {
      throw new Error("Invalid domain");
    }
    domainHostname = domainHostname.replace(/\/.well-known\/did.json$/, "");
    domainHostname = domainHostname.replace(/\/did.json$/, "");
    did = `did:web:${domainHostname?.replace(/\//g, ":")}`;
  }
  const resolver = new Resolver({
    ...getResolver$1()
  });
  const doc = await resolver.resolve(did);
  return {
    wellKnownDid: doc?.didDocument,
    did
  };
}, "queryDidDocument");
const resolve = /* @__PURE__ */ __name(async (did) => {
  try {
    const resolver = getResolver();
    const doc = await resolver.resolve(did);
    if (doc.didResolutionMetadata && "contentType" in doc.didResolutionMetadata) {
      delete doc.didResolutionMetadata.contentType;
    }
    return doc;
  } catch {
    throw new Error("Failed to resolve did");
  }
}, "resolve");
const resolveRepresentation = /* @__PURE__ */ __name(async (did, resolutionOptions) => {
  const { accept } = resolutionOptions || {};
  if (accept && !SUPPORTED_CONTENT_TYPES.includes(accept)) {
    return {
      didResolutionMetadata: {
        error: "representationNotSupported",
        message: `Content type ${accept} is not supported.`
      },
      didDocumentStream: "",
      didDocumentMetadata: {}
    };
  }
  try {
    const resolver = getResolver();
    const doc = await resolver.resolve(did, {
      accept
    });
    const { didDocument, didResolutionMetadata, ...rest } = doc;
    if (didDocument && accept === "application/did+json") {
      delete didDocument["@context"];
    }
    const response = {
      ...rest,
      didDocumentStream: didDocument ? JSON.stringify(didDocument) : "",
      didResolutionMetadata
    };
    if (!didResolutionMetadata.error) {
      response.didResolutionMetadata.contentType = accept ?? didResolutionMetadata.contentType;
    }
    return response;
  } catch {
    throw new Error("Failed to resolve did");
  }
}, "resolveRepresentation");
const dereference = /* @__PURE__ */ __name(async (did, dereferenceOptions) => {
  const { accept } = dereferenceOptions || {};
  const isInvalidRequest = accept && !SUPPORTED_CONTENT_TYPES.includes(accept) || did.includes("?") || did.includes("/");
  if (isInvalidRequest) {
    return {
      dereferencingMetadata: {
        error: "notFound"
      },
      contentStream: "",
      contentMetadata: {}
    };
  }
  try {
    const resolver = getResolver();
    const { didDocument, didResolutionMetadata: dereferencingMetadata, didDocumentMetadata: contentMetadata } = await resolver.resolve(did, {
      accept
    });
    if (dereferencingMetadata.error) {
      const error = dereferencingMetadata.error === "invalidDid" ? "invalidDidUrl" : dereferencingMetadata.error;
      return {
        dereferencingMetadata: {
          ...dereferencingMetadata,
          error
        },
        contentStream: "",
        contentMetadata
      };
    }
    dereferencingMetadata.contentType = accept ?? dereferencingMetadata.contentType;
    if (did.includes("#")) {
      const verificationMethod = didDocument.verificationMethod?.find((vm) => vm.id === did);
      if (verificationMethod) {
        return {
          contentStream: JSON.stringify(verificationMethod),
          contentMetadata,
          dereferencingMetadata
        };
      }
    }
    const documentToReturn = {
      ...didDocument
    };
    if (documentToReturn && accept === "application/did+json") {
      delete documentToReturn["@context"];
    }
    return {
      contentStream: JSON.stringify(documentToReturn),
      contentMetadata,
      dereferencingMetadata
    };
  } catch {
    throw new Error("Failed to dereference did");
  }
}, "dereference");

export { dereference, queryDidDocument, resolve, resolveRepresentation };
